const open = ({ modal }) => modal?.footer?.open || false;

export { open };
